import React from "react";
import SignUpCard from "../../Components/SignUpCard";
import { TbTruckDelivery, TbUser } from "react-icons/tb";
import { Handshake, TruckIcon, UserPlus } from "lucide-react";

function Register() {
  const signUpOptions = [
    // {
    //   icon: (
    //     <Handshake className="text-amber-500 h-[5rem] p-2 border-4  w-[5rem] border-amber-500 mb-5 rounded-lg text-[10rem]" />
    //   ),
    //   title: "Driver Sign Up",
    //   description:
    //     "Take your business to the next level, consolidate your workflow into one platform with a powerful and nimble transport management solution.",
    //   buttonText: "Get Started",
    //   url: "/register/driver",
    // },
    {
      icon: (
        <TruckIcon className="text-amber-500 h-[5rem] p-2 border-4  w-[5rem] border-amber-500 mb-5 rounded-lg text-[10rem]" />
      ), // You'll need to replace this with the actual truck icon URL
      title: "Carrier Sign Up",
      description:
        "A car hauler dispatch software that streamlines everything into one view, effortlessly integrates your entire workflow and automates partner notifications.",
      buttonText: "Get Started",
      url: "/register/carrier",
    },
    // user sign up
    {
      icon: (
        <UserPlus className="text-amber-500 h-[5rem] p-2 border-4  w-[5rem] border-amber-500 mb-5 rounded-lg text-[10rem]" />
      ), // You'll need to replace this with the actual truck icon URL
      title: "User Sign Up",
      description:
        "A car hauler dispatch software that streamlines everything into one view, effortlessly integrates your entire workflow and automates partner notifications.",
      buttonText: "Get Started",
      url: "/register/user",
    },
  ];

  return (
    <div className="min-h-screen bg-[#181714] p-6 md:p-12">
      <div className="animate-fade">
        {/* image and register */}
        <div className="flex flex-col h-[10rem] justify-start">
          <img
            src="/img/cajuu_logo.png"
            alt="Cajuu Logo"
            className="w-[5rem]"
          />
          <h1 className="text-3xl md:text-4xl font-semibold text-white">
            Register
          </h1>
        </div>

        <div className="max-w-4xl mx-auto">
          {signUpOptions.map((option, index) => (
            <SignUpCard
              key={index}
              icon={option.icon}
              title={option.title}
              description={option.description}
              buttonText={option.buttonText}
              url={option.url}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Register;
